export const ORDER_LIST_LIMIT = 20;
export const MAX_ORDERS_SELECTED_FOR_PRINT_PACKING_SLIPS = 20;
